import { NavLink, Outlet } from 'react-router-dom';
import { SpaghettiDivider } from '../../components/SpaghettiDivider';

const tabStil = ({ isActive }: { isActive: boolean }) => ({
  padding: '0.4rem 0.8rem',
  borderRadius: 999,
  textDecoration: 'none',
  color: isActive ? '#fff' : 'var(--espresso)',
  background: isActive ? 'var(--erdbeere)' : 'var(--sahne)',
  border: '1px solid var(--raspel)',
  fontWeight: 600,
  fontSize: '0.9rem',
});

/**
 * Verwaltung (Bauphase 7) — nur für Verwalter. Rahmen mit Unternavigation,
 * der eigentliche Inhalt kommt aus den Kind-Routen (siehe App.tsx).
 */
export function Verwaltung() {
  return (
    <div className="container">
      <p className="label">Nur für Verwalter</p>
      <h1>Verwaltung</h1>
      <SpaghettiDivider />

      <nav style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
        <NavLink to="/app/verwaltung/nutzer" style={tabStil}>
          Nutzer
        </NavLink>
        <NavLink to="/app/verwaltung/verkostungen" style={tabStil}>
          Verkostungen
        </NavLink>
        <NavLink to="/app/verwaltung/eisdielen" style={tabStil}>
          Eisdielen
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
}
